module.exports = __webpack_public_path__ + "img/bf30c92.jpg";